<template>
  <button
    type="button"
    class="action-row"
    :class="[
      tone === 'danger' && 'action-row--danger',
      tone === 'success' && 'action-row--success',
      flush && 'action-row--flush',
      active && 'action-row--active',
    ]"
    :aria-current="active || undefined"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <span v-if="$slots.icon" class="action-row-icon" aria-hidden="true">
      <slot name="icon" />
    </span>
    <span class="action-row-body">
      <span class="action-row-title">{{ title }}</span>
      <span v-if="description" class="action-row-desc">{{ description }}</span>
    </span>
    <span v-if="$slots.trailing" class="action-row-trailing">
      <slot name="trailing" />
    </span>
  </button>
</template>

<script setup lang="ts">
/**
 * Full-width tappable list row — the "reset password" / "sign out" / bank-picker
 * rows several panels hand-rolled as a `<button>` with inline flex + border.
 * Optional #icon (leading glyph) and #trailing (chevron/badge) slots. `tone`
 * tints the label ("danger" destructive, "success" for add/create rows).
 * `flush` drops the standalone card chrome for a borderless divider row inside
 * a list (nav selectors, action sheets); `active` marks the selected row.
 */
defineProps<{
  title: string
  description?: string
  tone?: "default" | "danger" | "success"
  /** Borderless list-row style with a bottom divider (for row lists). */
  flush?: boolean
  /** Selected/highlighted state. */
  active?: boolean
  disabled?: boolean
}>()

defineEmits<{
  (e: "click", event: MouseEvent): void
}>()
</script>
